module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAABBklEQVQ4jaXSMS8EURTF8d9MxAfYkIgoEIVoKbDRCZUCiZpCKSs+h4qPsYVKtIqNjXoT0YjYQrPoNhISUeyVjDG7GZzu3HvuP++9+5Ju3SAdo4ZTHPULJQMgk7hDig/M4L4omA44xX6mn4YvVD/IEHZztb2ol4ZsYzxXG8NOUTjp1q3jABMYxQiG+8DhDU/o4BEnSbeuE4N/1XMatP+onWIDN38E3GIzRRsraPwScIUqHr6284I1nJcEXGA15r6t+DXoZdSIvDwElkpCqlmThSRYLglZjPwPyCwqufA7zvQ+WFYVzBVBpnPBa8xjCwvhs5oqglyiqffih3pXa0WvFb4W/WbkwSfD5zLbfL6fZQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/Collection_curr.png
// module id = HwA8
// module chunks = 0